module.exports = __webpack_public_path__ + "static/img/easily-access-credit-cards.c3b8540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img-text/images/easily-access-credit-cards.svg
// module id = SFnC
// module chunks = 26